import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { PromotionBanner } from '@evermile/customer-tracking';
import LayoutEnum = PromotionBanner.LayoutEnum;

@Component({
  selector: 'common-promotion-banner',
  templateUrl: './promotion-banner.component.html',
  styleUrls: ['./promotion-banner.component.scss'],
})
export class PromotionBannerComponent implements OnChanges {
  @Input({ required: true }) brandColor!: string;
  @Input({ required: true }) textColor!: string;
  @Input({ required: true }) banner!: PromotionBanner;
  @Input({ required: true }) orderStatus?: string;
  @Input() contained?: boolean;
  protected readonly LayoutEnum = LayoutEnum;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['banner']) {
      this.banner.imageUrl = this.banner?.imageUrl ? this.banner?.imageUrl + '?t=' + new Date().getTime() : undefined;
    }
  }
}
